module.exports = __webpack_public_path__ + "img/border-bottom-right.1e97d174.svg";